export function textTitle_filedMirgrants(node) {
  return node
}
